import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.purchaseOrders.PurchaseOrderDetailView.';
  public static readonly itemNumberTitle = `${Id.prefix}itemNumberTitle`;
  public static readonly imageTitle = `${Id.prefix}imageTitle`;
  public static readonly frameTitle = `${Id.prefix}frameTitle`;
  public static readonly frameTitleAndDescription = `${Id.prefix}frameTitleAndDescription`;
  public static readonly optionsTitle = `${Id.prefix}optionsTitle`;
  public static readonly notesToManufacturer = `${Id.prefix}notesToManufacturer`;
  public static readonly frameConfiguration = `${Id.prefix}frameConfiguration`;
  public static readonly information = `${Id.prefix}information`;
  public static readonly supplierNote = `${Id.prefix}supplierNote`;
  public static readonly warning = `${Id.prefix}warning`;
  public static readonly criticalError = `${Id.prefix}criticalError`;
  public static readonly requireValidation = `${Id.prefix}requireValidation`;
  public static readonly tags = `${Id.prefix}tags`;
  public static readonly quantityTitle = `${Id.prefix}quantityTitle`;
  public static readonly priceTitle = `${Id.prefix}priceTitle`;
  public static readonly reference = `${Id.prefix}reference`;
  public static readonly pleaseProvideReference = `${Id.prefix}pleaseProvideReference`;
  public static readonly orderTotal = `${Id.prefix}orderTotal`;
}

export class LangPurchaseOrderDetailView {
  private constructor() {}
  public static itemNumberTitle(): string {
    return interpolate(Id.itemNumberTitle);
  }
  public static imageTitle(): string {
    return interpolate(Id.imageTitle);
  }
  public static frameTitle(): string {
    return interpolate(Id.frameTitle);
  }
  public static frameTitleAndDescription(): string {
    return interpolate(Id.frameTitleAndDescription);
  }
  public static optionsTitle(): string {
    return interpolate(Id.optionsTitle);
  }
  public static notesToManufacturer(): string {
    return interpolate(Id.notesToManufacturer);
  }
  public static frameConfiguration(): string {
    return interpolate(Id.frameConfiguration);
  }
  public static information(): string {
    return interpolate(Id.information);
  }
  public static supplierNote(): string {
    return interpolate(Id.supplierNote);
  }
  public static warning(): string {
    return interpolate(Id.warning);
  }
  public static criticalError(): string {
    return interpolate(Id.criticalError);
  }
  public static requireValidation(): string {
    return interpolate(Id.requireValidation);
  }
  public static tags(): string {
    return interpolate(Id.tags);
  }
  public static quantityTitle(): string {
    return interpolate(Id.quantityTitle);
  }
  public static priceTitle(): string {
    return interpolate(Id.priceTitle);
  }
  public static reference(): string {
    return interpolate(Id.reference);
  }
  public static pleaseProvideReference(): string {
    return interpolate(Id.pleaseProvideReference);
  }
  public static orderTotal(): string {
    return interpolate(Id.orderTotal);
  }
}

export class PurchaseOrderDetailViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.itemNumberTitle, 'Item #', 'Title for item number column');
    register.add(Id.imageTitle, 'Image', 'Title for image column');
    register.add(Id.frameTitle, "{{glossary 'frame-title'}}", 'Frame title fallback');
    register.add(
      Id.frameTitleAndDescription,
      "{{glossary 'frame-title'}} and Description",
      'Column title for frame title and description'
    );
    register.add(Id.optionsTitle, 'Options', 'Options column title');
    register.add(Id.notesToManufacturer, 'Notes to Manufacturer', 'Notes to Manufacturer label');
    register.add(Id.frameConfiguration, 'Frame Configuration', 'Frame configuration label');
    register.add(Id.information, 'Information', 'Information label');
    register.add(Id.supplierNote, 'Supplier Note', 'Supplier Note label');
    register.add(Id.warning, 'Warning', 'Warning label');
    register.add(Id.criticalError, 'Critical Error', 'Critical Error label');
    register.add(Id.requireValidation, 'Require Validation', 'Require Validation label');
    register.add(Id.tags, 'Tags', 'Tags label');
    register.add(Id.quantityTitle, 'Qty', 'Quantity column title');
    register.add(Id.priceTitle, 'Price', 'Price column title');
    register.add(Id.reference, 'Reference', 'Reference label');
    register.add(Id.pleaseProvideReference, 'Please provide a reference', 'Prompt to provide a reference');
    register.add(
      Id.orderTotal,
      "{{glossary 'purchase-order'}} Total",
      'Label on the items table grand-total footer row'
    );
  }
}
